import firstIcon from '../asset/processIcon-1.svg'
import secondIcon from '../asset/processIcon-2.svg'
import thirdIcon from '../asset/processIcon-3.svg'

export const procedureCradData = {
  title: 'How this works',
  content: [
    {
      icon: firstIcon,
      text: (
        <>
          <b>Consent</b> to share your data with us.
        </>
      ),
    },
    {
      icon: secondIcon,
      text: (
        <>
          <b>Connect</b> to your provider to authorise data sharing.
        </>
      ),
    },
    {
      icon: thirdIcon,
      text: (
        <>
          <b>Confirm</b> what you've chosen to share and that you're happy to
          share it with us.
        </>
      ),
    },
  ],
}
